import { render, staticRenderFns } from "./twilio-numbers-table.vue?vue&type=template&id=03bedf03"
import script from "./twilio-numbers-table.vue?vue&type=script&lang=js"
export * from "./twilio-numbers-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports